import { ChartElementHandler } from './chart.element-handler';

export class DotChartElementHandler extends ChartElementHandler<'chartDot'> {
  readonly type = 'chartDot';
  readonly flipXY = false;
}
